import { useState } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d9q8ikcnlsngrm4lltd0';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('contact_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setMessage('订阅成功！感谢你的关注。');
      setEmail('');
      return;
    }

    setStatus('loading');

    try {
      const payload = new URLSearchParams();
      payload.append('email', email);

      const response = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch (_err) { /* parse error */ }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢你的关注，最新吃瓜内容将第一时间送达。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试';
        setStatus('error');
        setMessage(serverMsg);
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络连接后重试');
    }
  };

  return (
    <section className="py-12 md:py-16 bg-gradient-to-br from-primary-500 to-primary-600">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-3">
          不想错过任何一个瓜？
        </h2>
        <p className="text-primary-100 mb-8 text-sm md:text-base">
          订阅吃瓜网每日推送，最新娱乐八卦资讯直达你的邮箱
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form="true"
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="text"
            name="contact_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="honeypot-field"
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱地址"
            required
            className="flex-1 px-4 py-3 rounded-xl bg-background-50 text-foreground-800 placeholder:text-foreground-400 text-sm outline-none focus:ring-2 focus:ring-accent-300 transition-all"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-6 py-3 rounded-xl bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-all disabled:opacity-60 cursor-pointer whitespace-nowrap"
          >
            {status === 'loading' ? '订阅中...' : '立即订阅'}
          </button>
        </form>

        {status !== 'idle' && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-accent-200' : 'text-red-200'}`}>
            {message}
          </p>
        )}

        <p className="text-xs text-primary-200/70 mt-4">
          我们尊重你的隐私，随时可以取消订阅
        </p>
      </div>
    </section>
  );
}